import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import loadable from "@loadable/component";
import CheckoutContainer from "core-web/containers/CheckoutContainer";
import styled from "theme/libs/styled";
import TextStyles from "theme/components/text/TextStyles";
import PageWrapper from "theme/components/wrappers/PageWrapper";

const UnderMaintenance = styled("div")`
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100vh;
    padding: 16px;
    color: ${({ theme }) => theme.colors.red};
`;

const components = {
    checkout: loadable(() => import("theme/components/checkout/Checkout")),
    empty: loadable(() => import("theme/components/checkout/Empty")),
    loading: loadable(() => import("theme/components/checkout/Loading")),
};

const Default = () => {
    const { t } = useTranslation();
    const settings = useSelector(({ application }) => application.config.options.settings) || {};
    const { maintenance_switch: maintenanceSwitch, maintenance_text: maintenanceText } = settings;

    return (
        <PageWrapper isUnderneathNavbar>
            {maintenanceSwitch ? (
                <UnderMaintenance>
                    <TextStyles textStyles="Buenos Aires/48-90 SemiBold">
                        {maintenanceText || t("maintenance")}
                    </TextStyles>
                </UnderMaintenance>
            ) : (
                <CheckoutContainer components={components} />
            )}
        </PageWrapper>
    );
};

export default Default;
